import { render, staticRenderFns } from "./UsersGroupsPermissionsDialog.vue?vue&type=template&id=0fb8e8a8&scoped=true&"
import script from "./UsersGroupsPermissionsDialog.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsPermissionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./UsersGroupsPermissionsDialog.vue?vue&type=style&index=0&id=0fb8e8a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8e8a8",
  null
  
)

export default component.exports